import React, { useState, useEffect, useRef, createRef } from 'react'
import Viewport from './Viewport'

function Viewports( data ) {
    const [ viewportsStructure, setViewportsStructure ] = useState( [] )        
    const [ mediaConnections, setMediaConnections ] = useState([]) // This replaces mediaRefs
    const localVideo = useRef( [] )
    const [ smallScreen, setSmallScreen ] = useState( false )
    const prevParticipants = useRef( data.roomData?.participants ) 
    const prevVisitors = useRef( data.roomData?.visitors )
    const [ iceServersTest, setIceServers ] = useState(null);
    const drawViewports = ()=>{
        if( data.roomData === null ) return( <div className = 'roomContent' key={ 1 }><h3>Loading...</h3></div> )
        if( data.roomData && data.roomData.gameConfig === -1 ) return( <div className = "roomDoesNotExistHolder" key={ 1 }><div className="roomDoesNotExistText"><h3>The table you trying to join is full</h3></div></div> )
        if( data.roomData && data.roomData.gameConfig !== -1 && data.localMedia && data.localMedia.active ){ return( <div className = 'viewportContainer' key={ 1 }>{ viewportsStructure }</div> )}
        if( data.roomData && data.roomData.gameConfig !== -1 && data.localMedia && !data.localMedia.active ){ return( <div className = 'viewportContainerAwait' key={ 1 }>{ viewportsStructure }</div> )}
    }

    useEffect(() => {
        const initPeerConnection = async () => {
        try {
            // Your static TURN server configuration
            let myTurnServers = []
    
            // Fetch Metered TURN credentials (this call might vary based on your API)
            let meteredTurnServers = []
            if (process.env.NODE_ENV === "production") {
                myTurnServers = [
                    {
                        urls: "turn:147.182.164.7:3478",
                        username: "poker",
                        credential: "pokerstream",
                    },
                    {
                        urls: "turns:147.182.164.7:5349",
                        username: "poker",
                        credential: "pokerstream",
                    },
                ];
                const response = await fetch("/turn-credentials")
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status ${ response.status }`)
                }
                const meteredData = await response.json();
                meteredTurnServers = meteredData || [];
            } else {
                const response = await fetch(
                    "https://pokerstream.metered.live/api/v1/turn/credentials?apiKey=99f5665c667d9d7e0c39fba2a007a7e8d64a"
                );
                if( !response.ok ) {
                    throw new Error( `Network response was not ok, status ${ response.status }` )
                }

                const meteredData = await response.json()
                meteredTurnServers = meteredData || []
            }
    
            // Combine both TURN server configurations
            const combinedIceServers = [...myTurnServers, ...meteredTurnServers]
            setIceServers(combinedIceServers)
            
            }catch( err ) {
                console.error( "Failed to fetch ICE servers:", err )
            }
        };
        initPeerConnection();
      }, []);

    // useEffect(() => {
    //     const initPeerConnection = async () => {
    //       try {
    //         // Instead of fetching from the Metered API,
    //         // provide your TURN server configuration directly.
    //         const servers = {
    //           iceServers: [
    //             {
    //               // Non-TLS connection on port 3478
    //               urls: "turn:147.182.164.7:3478",
    //               username: "poker",
    //               credential: "pokerstream",
    //             },
    //             {
    //               // TLS/secure connection on port 5349 (optional)
    //               urls: "turns:147.182.164.7:5349",
    //               username: "poker",
    //               credential: "pokerstream",
    //             },
    //           ],
    //         };
    
    //         setIceServers(servers);
    //       } catch (err) {
    //         console.log( 'NNN' )
    //         console.log("Failed to set ICE servers:", err);
    //       }
    //     };
    
    //     initPeerConnection();
    //   }, []);

    // useEffect(() => {
    //     const initPeerConnection = async () => {
    //         try {
    //             // If you've configured an Nginx proxy for the metered API,
    //             // use a relative URL – otherwise, you can use the full URL.
    //             const response = process.env.NODE_ENV === 'production' ? await fetch("/turn-credentials") : await fetch("https://pokerstream.metered.live/api/v1/turn/credentials?apiKey=99f5665c667d9d7e0c39fba2a007a7e8d64a")
    //             if (!response.ok) {
    //             throw new Error(`Network response was not ok, status ${response.status}`);
    //             }
    //             const servers = await response.json();
    //             setIceServers(servers);
    //         } catch (err) {
    //             console.error('Failed to fetch ICE servers:', err);
    //         }
    //     };

    //     initPeerConnection();
    // }, []);


    useEffect(() => {
        // set up local video 
        if( data.localMedia && data.localMedia.active ){
            localVideo.current.forEach(( videoEl ) => {
                if( videoEl ){
                    videoEl.srcObject = data.localMedia;
                    videoEl.play().catch( error => console.log( 'Error playing video:', error ))
                }
            })
        }
    }, [ data.localMedia, data.soundEnabled ])


    useEffect(()=>{
        data.RTCmessage.forEach(( message )=>{
            // console.log( '2' )
            switch( message.type ){
                case 'videoOffer' : {
                    handleRTCVideoOffer( message )
                    data.removeRTCMessage( message.messageId )
                }
                break

                case 'videoAnswer' : {
                    handleRTCVideoAnswer( message, data.removeRTCMessage )
                }
                break

                case 'ICEcandidate' : {
                    handleICECandidate( message, data.removeRTCMessage )
                }
                break
            }
        })
    }, [ data.RTCmessage, mediaConnections, data.soundEnabled ])

    useEffect(()=>{ 
        if( data.width > 1000 ){
            setSmallScreen( false )
        }else{
            setSmallScreen( true )
        }
    },[ data.width ])


    useEffect(() => {
        const currentParticipants = data.roomData?.participants

        if( currentParticipants ) buildViewportsStructure( data.roomData.participants )
    //}, [ data.roomData.participants, data.roomData.visitors, mediaConnections, smallScreen, data.soundEnabled ])
    }, [ data.roomData, mediaConnections, smallScreen, data.soundEnabled, data.user ])



    useEffect(() => {
        if( prevParticipants.current ){
            if( iceServersTest ){
                participantsIdHasChanged( prevParticipants.current, data.roomData.participants ) ? updateMediaConnections() : null
            }
        }else{
            if( iceServersTest ){
                updateMediaConnections()
            }
        }
    }, [ data.roomData, data.localMedia, mediaConnections, prevParticipants.current, data.soundEnabled, iceServersTest ])


    useEffect(() => {     
        return () => {
            closeAllMediaConnections( mediaConnections )
            setMediaConnections([])
            // setListForInitMediaConnections([])
            prevParticipants.current = null
            prevVisitors.current = null
        }
    }, [])


    function updateMediaConnections() {
        createConnectionsForNewPlayers()
        removeConnectionsForPlayersWhoLeft()
        // prevParticipants.current = data.roomData?.participants
    }

    function createConnectionsForNewPlayers () {
        // console.log( 'createConnectionsForNewPlayers' )

        let newConnection = [ ...mediaConnections ]
        let updateMedaiconnections = false

        if( data.roomData && data.roomData.participants && data.localMedia && data.localMedia.active ){
            
            const participantIsHere = newConnection.some((connection) =>
                data.roomData.participants.some((participant) =>
                    participant.participant && participant.participant._id === connection._id
                )
            );

            if( !participantIsHere ){
                data.roomData.participants.map(( participant )=>{
                    if( participant.participant && participant.participant._id !== data.user._id ){
                        const peer = {
                            _id: participant.participant._id,
                            RTC: new RTCPeerConnection( { iceServers: iceServersTest } ),
                            remoteStream: null
                        }
        
                        data.localMedia.getTracks().forEach( track => {
                            peer.RTC.addTrack( track, data.localMedia )
                        })

                        const setVideoBitrate = () => {
                            const sender = peer.RTC.getSenders().find(( s ) => s.track && s.track.kind === "video" )
                            if( sender ) {
                                const parameters = sender.getParameters()
                                if (!parameters.encodings) {
                                    parameters.encodings = [{}]
                                }
                                parameters.encodings[ 0 ].maxBitrate = 500000
                                sender.setParameters( parameters ).catch(( error ) => {
                                    console.error( "Failed to set video bitrate:", error )
                                })
                            }
                        }

                        setVideoBitrate()
        
                        peer.RTC.ontrack = ( event ) => {
                            peer.remoteStream = event.streams[ 0 ]
                        }
        
                        peer.RTC.onicecandidate = ( event ) => {
                            if( event.candidate ) {
                                data.socket.socket.emit( 'RTCmessage', {
                                    candidate: event.candidate,
                                    userID: data.user._id,
                                    targetID: participant.participant._id,
                                    type: 'ICEcandidate',
                                    messageId: generateUniqueId()
                                })
                            }
                        }
        
                        peer.RTC.onconnectionstatechange = () => {
                            if ( peer.RTC.connectionState === 'disconnected' ) {
                                // Close the connection
                                peer.RTC.close();
                                // Remove the connection from newMediaConnections
                                newConnection = newConnection.filter( conn => conn._id !== peer._id )
                                // Update the mediaConnections state
                                setMediaConnections( newConnection )
                                updateMedaiconnections = true
                            }
                        }
        
                        const createOffer = async () => {
                            const offer = await peer.RTC.createOffer()
                            await peer.RTC.setLocalDescription( offer )
                            data.socket.socket.emit( 'RTCmessage', {
                                sdp: peer.RTC.localDescription,
                                userID: data.user._id,
                                targetID: participant.participant._id,
                                type: 'videoOffer',
                                messageId: generateUniqueId()
                            })
                        }
                        createOffer()
                        newConnection.push( peer ) 
                        updateMedaiconnections = true
                    }
                })
                prevParticipants.current = data.roomData?.participants
                setMediaConnections( newConnection )
                

            }
        }
    }

    function removeConnectionsForPlayersWhoLeft () {
        // console.log( 'removeConnectionsForPlayersWhoLeft' )

        let newConnections = [ ...mediaConnections ]
        let updateMedaiconnections = false

        newConnections.map(( connection )=>{

            const participantIsHere = data.roomData.participants.some(( participant )=>{ if( participant.participant ) return participant.participant._id === connection._id })

            
            // console.log( participantIsHere )
            if( !participantIsHere ){
                // stop connection
                connection.RTC.close()

                //remove connection
                newConnections = newConnections.filter( conn => conn._id !== connection._id )
                updateMedaiconnections = true
            }
        })
        if( updateMedaiconnections ) setMediaConnections( newConnections )
    }

    function participantsIdHasChanged(prevArray, currentArray) {
        // Handle cases where one or both arrays are empty or undefined
        if (!prevArray || prevArray.length === 0) return !!(currentArray && currentArray.length > 0);
        if (!currentArray || currentArray.length === 0) return !!(prevArray && prevArray.length > 0);
    
        // Compare the two arrays for changes in participant IDs
        return prevArray.some((prevItem) => {
            if (prevItem.participant && prevItem.participant._id) {
                const matchingCurrentItem = currentArray.find(
                    (currItem) =>
                        currItem.participant &&
                        currItem.participant._id === prevItem.participant._id
                );
                return !matchingCurrentItem; // Return true if no match is found
            }
            return false; // Skip items without a valid participant or _id
        });
    }
    
    function closeAllMediaConnections( mediaConnections)  {      
        // Additional logic to handle mediaConnections can be added here
        // For example, closing all peer connections
        if( mediaConnections && mediaConnections.length ){
            mediaConnections.forEach(connection => {
                if ( connection.RTC ) {
                    connection.RTC.close()
                }
            })
        }
    }

    function handleRTCVideoOffer(message) {
        try {
            console.log("handleRTCVideoOffer");
            // Ensure mediaConnections is always an array
            let newMediaConnections = Array.isArray(mediaConnections) ? [...mediaConnections] : [];
            let peerConnection = newMediaConnections.find(ref => ref._id === message.caller);
    
            // Close any existing connection for the caller
            newMediaConnections.forEach(conn => {
                if (conn._id === message.caller && conn.RTC) {
                    conn.RTC.close();
                }
            });
    
            // Filter out the closed connection
            newMediaConnections = newMediaConnections.filter(conn => conn._id !== message.caller);
    
            // Validate iceServersTest
            if (!iceServersTest || !Array.isArray(iceServersTest)) {
                console.error("ICE servers are not available or invalid.");
                return;
            }
    
            // Create a new connection for the offer
            (async () => {
                // console.log("Creating new peer connection...");
                peerConnection = {
                    _id: message.caller,
                    RTC: null,
                    remoteStream: null,
                };
    
                peerConnection.RTC = new RTCPeerConnection({ iceServers: iceServersTest });
    
                // Add local media tracks to the connection
                data.localMedia.getTracks().forEach(track => {
                    peerConnection.RTC.addTrack(track, data.localMedia);
                });
    
                // Handle remote stream
                peerConnection.RTC.ontrack = event => {
                    peerConnection.remoteStream = event.streams[0];
                };
    
                // Handle ICE candidates
                peerConnection.RTC.onicecandidate = event => {
                    if (event.candidate) {
                        data.socket.socket.emit("RTCmessage", {
                            candidate: event.candidate,
                            userID: data.user._id,
                            targetID: message.caller,
                            type: "ICEcandidate",
                            messageId: generateUniqueId(),
                        });
                    }
                };
    
                // Handle connection state changes
                peerConnection.RTC.onconnectionstatechange = () => {
                    if (peerConnection.RTC.connectionState === "disconnected") {
                        try {
                            const updatedConnections = mediaConnections.filter(
                                conn => conn.connectionState !== "closed"
                            );
                            setMediaConnections(updatedConnections);
                        } catch (error) {
                            console.error("Error updating media connections:", error);
                        }
                    }
                };
    
                // Set remote description and create an answer
                try {
                    await peerConnection.RTC.setRemoteDescription(new RTCSessionDescription(message.sdp));
                    const answer = await peerConnection.RTC.createAnswer();
                    await peerConnection.RTC.setLocalDescription(answer);
    
                    // Send the answer back to the caller
                    data.socket.socket.emit("RTCmessage", {
                        sdp: peerConnection.RTC.localDescription,
                        userID: data.user._id,
                        targetID: message.caller,
                        type: "videoAnswer",
                        messageId: generateUniqueId(),
                    });
    
                    // console.log("Answer sent to caller.");
                } catch (error) {
                    console.error("Error setting up RTC connection:", error);
                }
    
                // Add the new connection to the list
                newMediaConnections.unshift(peerConnection);
                setMediaConnections(newMediaConnections);
            })();
        } catch (err) {
            console.error("Error in handleRTCVideoOffer:", err);
        }
    }

    function handleRTCVideoAnswer( message, callback ) {
        console.log( 'handleRTCVideoAnswer' )
        const newMediaConnections = mediaConnections
        const mediaConnection = newMediaConnections.find( ref => ref._id === message.caller )

        if ( !mediaConnection ) {
            console.log( 'No media connection found for user:', message.caller )
            return
        }
        
        // creating new peer connection
        const peerConnection = mediaConnection.RTC
    
        if ( !peerConnection ) {
            console.log( 'No RTCPeerConnection found for user:', message.caller )
            return
        }
    
        peerConnection.setRemoteDescription( new RTCSessionDescription( message.sdp ))
            .then(() => {
            })
            .catch( error => {
                console.log( 'UUU Error setting remote description:', error )
            })

        callback( message.messageId )
    }
    
    function handleICECandidate( message, callback ) {
        console.log( 'handleICECandidate' )
        try{
            let mediaConnection
            
            let newMediaConnections = [ ...mediaConnections ]
    
            if( newMediaConnections ){ mediaConnection = newMediaConnections.find( ref => ref._id === message.caller )}

            if ( !mediaConnection ) {
                // console.log( 'no media connections' )
                return
            }
        
            const peerConnection = mediaConnection.RTC
        
            if ( peerConnection && peerConnection.signalingState !== 'closed' ) {
                peerConnection.addIceCandidate( new RTCIceCandidate( message.candidate ))
                .then(() => {
                    setMediaConnections( newMediaConnections )
                })
                .catch( error => {
                    console.log( 'Error adding ICE candidate:', error )
                })

                if( callback ) callback( message.messageId )
            }

        }catch( err ){
            console.log( err )
        }
    }
    
    function generateUniqueId() { return Math.random().toString( 36 ).substr( 2, 9 ) }

    function buildViewportsStructure( participants ) {
        // console.log( 'buildViewportsStructure' )
        let newViewportsStructure 
        
        if( !smallScreen ){
            newViewportsStructure = data.roomData.participants.map(( participant, i ) => {
                const currentPlayer =  ( status )=>{ if( status === true ){ return 'currentPlayer' }else{ return null } }
    
                if( data.user && data.user._id  ){
                    if( participant.status === 'empty' ){
                        return(
                            <div className = 'viewportWrapper' key={ i }>
                                <div className = "viewportHolder" onClick={ ()=> sitDown( i ) }>
                                    <div className = { currentPlayerIsSetOnTheTable( data.user._id  ) ? 'emptyViewport_unclickable' : 'emptyViewport' + " " + currentPlayer( participant.currentPlayer ) }>
                                        <span className = 'sitHere'>Sit here</span>
                                        {/* <video key={ i } ref={ el => localVideo.current[ i ] = el }  className = 'localVideo opacity' muted></video> */}
                                        <video key={ i } ref={ el => localVideo.current[ i ] = el }  muted className = 'localVideo opacity'></video>

                                    </div>
                                </div>
                            </div>
                        )
                    }else{
                        return(
                            <Viewport
                                key={ i }
                                localMedia = { data.localMedia }
                                toggleSound={ data.toggleSound }
                                soundEnabled={ data.soundEnabled }
                                avatar = { participant.participant.avatar }
                                ownStream = { data.user._id === participant.participant._id }
                                participant = { participant }
                                socket={ data.socket }
                                user={ data.user }
                                // ICEservers={ iceServers }
                                removeRTCMessage={ data.removeRTCMessage }
                                mediaConnections={ mediaConnections }
                                roomData={ data.roomData }
                                privateData={ data.privateData }
                                toggleGetChips={ data.toggleGetChips }
                                width={ data.width }
                            />
                        )
                    }
                }
            })

            setViewportsStructure( newViewportsStructure )
        }else{
            // let newParticipants = data.roomData.participants.slice()
            let newParticipants = participants.slice()
            
            // Step 1: Take the second half of the array
            let half = newParticipants.length / 2
            let secondHalf = newParticipants.slice( half )

            // Step 2: Remove the second half from the original array
            newParticipants.length = half

            // Step 3: Reverse the second half of the array
            let reversedSecondHalf = secondHalf.reverse()

            // Step 4: Merge the arrays
            let mixedParticipants = []
            for( let i = 0; i < newParticipants.length; i++ ){
                newParticipants[ i ].mobIndex = i
                mixedParticipants.push( newParticipants[ i ])
                if( i < reversedSecondHalf.length ) {
                    mixedParticipants.push( reversedSecondHalf[ i ])
                }
            }

            // if newParticipants contains more then 2 players and another array contains at least one player
            // or if reversedSecondHalf conntains more then 2 players and another array contains at least one player
            // arrays have to be aligned
            // in other cases arrays have to be adapted
            let viewportsHaveToBeAligned = null

            let pairs = []
            for( let i = 0; i < mixedParticipants.length; i += 2 ) {
                pairs.push([ mixedParticipants[ i ], mixedParticipants[ i + 1 ]])
            }

            // if only one pairs exists, shuffle array to make viewport one ater another, but not one above another
            let increment = 0
            pairs.map(( pair )=>{
                if( pair[ 0 ].status == 'player' &&  pair[ 1 ].status == 'player' ) increment += 1
                if( pair[ 0 ].status == 'player' &&  pair[ 1 ].status == 'empty' ) increment = 0
                if( pair[ 0 ].status == 'empty' &&  pair[ 1 ].status == 'player' ) increment = 0
            })
            if( increment === 1 ){
                let shuffledParticipants = participants.slice()

                let lastItem = shuffledParticipants.pop()  // Remove the last item
                shuffledParticipants.unshift( lastItem )  // Insert it at the first position
                
                buildViewportsStructure( shuffledParticipants )
            }else{
                if( participants.filter( item => item.status == 'player' ).length <= 1 ){
                    viewportsHaveToBeAligned = true
                }else{
                    // console.log( pairs )
                    pairs.map(( pair )=>{
                        // console.log(  pair.filter( item => item.status == 'player' ).length )
                        if( !viewportsHaveToBeAligned || viewportsHaveToBeAligned == false ){
                            pair.filter( item => item.status == 'player' ).length >= 2 ? viewportsHaveToBeAligned = true : viewportsHaveToBeAligned = false
                        }
                    })
                }
    
                newViewportsStructure = (
                    <div className="mobPairs">{
                        pairs.map(( pair, i ) => (
                            <div
                                key={`pair-${i}`} // Use a unique key by combining "pair-" with the index
                                className={viewportsHaveToBeAligned ? "mobPairJustified" : "mobPairEnlarged"}
                            >
                                {(() => {
                                    const currentPlayer = (status) => (status ? "currentPlayer" : null);
                                    if (data.user && data.user._id) {
                                        if (pair[0].status === "empty") {
                                            return (
                                                <div
                                                    className={
                                                        currentPlayerIsSetOnTheTable(data.user._id)
                                                            ? "viewportWrapperInvisible"
                                                            : "viewportWrapper"
                                                    }
                                                    key={`pair-0-${i}`} // Ensure unique key for the first item in the pair
                                                >
                                                    <div
                                                        className="viewportHolder"
                                                        onClick={() => sitDown(pair[0].index)}
                                                    >
                                                        <div
                                                            className={
                                                                currentPlayerIsSetOnTheTable(data.user._id)
                                                                    ? "emptyViewport_unclickable"
                                                                    : "emptyViewport" +
                                                                    " " +
                                                                    currentPlayer(pair[0].currentPlayer)
                                                            }
                                                        >
                                                            <span className="sitHere">Sit here</span>
                                                            <video
                                                                key={`video-0-${i}`} // Ensure unique key for the video element
                                                                ref={(el) => (localVideo.current[i] = el)}
                                                                className="localVideo opacity"
                                                                muted
                                                            ></video>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <Viewport
                                                    key={`viewport-0-${i}`} // Ensure unique key for the Viewport component
                                                    localMedia={data.localMedia}
                                                    toggleSound={data.toggleSound}
                                                    soundEnabled={data.soundEnabled}
                                                    avatar={pair[0].participant.avatar}
                                                    ownStream={data.user._id === pair[0].participant._id}
                                                    participant={pair[0]}
                                                    socket={data.socket}
                                                    user={data.user}
                                                    // ICEservers={iceServers}
                                                    removeRTCMessage={data.removeRTCMessage}
                                                    mediaConnections={mediaConnections}
                                                    roomData={data.roomData}
                                                    privateData={data.privateData}
                                                    toggleGetChips={data.toggleGetChips}
                                                    width={data.width}
                                                />
                                            );
                                        }
                                    }
                                })()}
                                {(() => {
                                    const currentPlayer = (status) => (status ? "currentPlayer" : null);
                                    if (data.user && data.user._id) {
                                        if (pair[1].status === "empty") {
                                            return (
                                                <div
                                                    className={
                                                        currentPlayerIsSetOnTheTable(data.user._id)
                                                            ? "viewportWrapperInvisible"
                                                            : "viewportWrapper"
                                                    }
                                                    key={`pair-1-${i}`} // Ensure unique key for the second item in the pair
                                                >
                                                    <div
                                                        className="viewportHolder"
                                                        onClick={() => sitDown(pair[1].index)}
                                                    >
                                                        <div
                                                            className={
                                                                currentPlayerIsSetOnTheTable(data.user._id)
                                                                    ? "emptyViewport_unclickable"
                                                                    : "emptyViewport" +
                                                                    " " +
                                                                    currentPlayer(pair[1].currentPlayer)
                                                            }
                                                        >
                                                            <span className="sitHere">Sit here</span>
                                                            <video
                                                                key={`video-1-${i}`} // Ensure unique key for the video element
                                                                ref={(el) => (localVideo.current[i] = el)}
                                                                className="localVideo opacity"
                                                                muted
                                                            ></video>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <Viewport
                                                    key={`viewport-1-${i}`} // Ensure unique key for the Viewport component
                                                    localMedia={data.localMedia}
                                                    toggleSound={data.toggleSound}
                                                    soundEnabled={data.soundEnabled}
                                                    avatar={pair[1].participant.avatar}
                                                    ownStream={data.user._id === pair[1].participant._id}
                                                    participant={pair[1]}
                                                    socket={data.socket}
                                                    user={data.user}
                                                    // ICEservers={iceServers}
                                                    removeRTCMessage={data.removeRTCMessage}
                                                    mediaConnections={mediaConnections}
                                                    roomData={data.roomData}
                                                    privateData={data.privateData}
                                                    toggleGetChips={data.toggleGetChips}
                                                    width={data.width}
                                                />
                                            );
                                        }
                                    }
                                })()}
                            </div>
                        ))}
                    </div>
                )
                setViewportsStructure( newViewportsStructure )
            }
        }

        

        function sitDown ( i ){
            if( !currentPlayerIsSetOnTheTable( data.user._id ) ){
                data.socket.socket.emit( 'sitDown', { sitIndex : i } )
            }
            // if( data.user.virtualMoney >= data.roomData?.gameConfig.minBuyIn ){
            //     if( !currentPlayerIsSetOnTheTable( data.user._id ) ){
            //         data.socket.socket.emit( 'sitDown', { sitIndex : i } )
            //     }
            // }else{
            //     data.toggleGetChips()
            // }
        }


        function currentPlayerIsSetOnTheTable ( n ){
            if( data.roomData && participants ){
                return participants.some( ( p )=>{
                    if( p.participant ){ return p.participant._id === n } 
                })
            }
        }
    }


  return( 
    <div className="drawnViewports">{ drawViewports() }</div> )
}

export default Viewports